"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenToReactComponent = void 0;
var Models_1 = require("../Models");
var TextComponent_1 = require("../TokenRenderers/TextComponent");
var LineBreak_1 = require("./LineBreak");
var Link_1 = require("./Link");
var MediaVariable_1 = require("./MediaVariable");
var TokenWidget_1 = require("./TokenWidget");
var Caption_1 = require("./Caption");
var QuoteColumnHeader_1 = require("./QuoteColumnHeader");
exports.tokenToReactComponent = new Map();
exports.tokenToReactComponent.set("text", TextComponent_1.Text);
exports.tokenToReactComponent.set(Models_1.InlineType.LineBreak, LineBreak_1.LineBreak);
exports.tokenToReactComponent.set(Models_1.InlineType.Link, Link_1.Link);
exports.tokenToReactComponent.set(Models_1.BlockType.MediaVariable, MediaVariable_1.MediaVariable);
exports.tokenToReactComponent.set(Models_1.InlineType.TokenWidget, TokenWidget_1.TokenWidget);
exports.tokenToReactComponent.set(Models_1.BlockType.Caption, Caption_1.Caption);
exports.tokenToReactComponent.set("quoteColumnHeader", QuoteColumnHeader_1.QuoteColumnHeader);
